<div class="panel-heading">
	<button type="button" class="close" (click)="onRemove(mRuleCondition)" style="color: #ffffff; margin-left: 10px; display: block">
		&times;
	</button>
	
	<!-- Minimize/Maximize Arrows -->
	<button (click)="mShowBody = !mShowBody" type="button" class="close"style="color: #ffffff; margin-left: 10px;">
		<i *ngIf="mShowBody" class="fa fa-angle-double-up"></i>
		<i *ngIf="!mShowBody" class="fa fa-angle-double-down"></i>
	</button>

	<h1 class="panel-title" style="display: inline-block; width: 90%">
		<div style="display: inline-block; width: 150px">
			<i class="fa fa-circle" ></i>&nbsp;PARAMETER
		</div>
		<span style="margin-left: 20px; font-size: 16px;">
			{{getParameterLabel()}} {{getOperatorLabel(mRuleCondition.operator)}} {{getValueLabel()}}
		</span>
	</h1>
</div>
        
<div *ngIf="mShowBody" class="panel-body" >
	<span>{{getParameterLabel()}}</span>
	<span class="dropdown">
		<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{{getOperatorLabel(mRuleCondition.operator)}}
			<span class="caret"></span>
		</button>
		<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto" >
			<li (click)="mRuleCondition.operator = operator" *ngFor="let operator of mAvailableOperators">
				<a class="ef">
					{{getOperatorLabel(operator)}}
				</a>
			</li>
		</ul>
	</span>
	<input class="form-control" type="text" [(ngModel)]="mRuleCondition.value" style="display: inline; width: 200px" />
</div>